module.exports = __webpack_public_path__ + "img/236.ed5c670b.png";